export enum HighlightSourceType {
  Algorithm = 'algorithm',
  Tagging = 'tagging',
  Comment = 'comment',
}
